var $ee002d249712e741$export$77ae2534b1d2e698 = /*#__PURE__*/ function(TypingTestState) {
    TypingTestState["NotStarted"] = "Not Started";
    TypingTestState["InProgress"] = "In Progress";
    TypingTestState["Completed"] = "Completed";
    return TypingTestState;
}({});


class $c5cbdfd32a1fc02c$export$c87cf3bdf124c216 {
    constructor(wordProvider, numberOfWords){
        this.currentWordIndex = 0;
        this._state = (0, $ee002d249712e741$export$77ae2534b1d2e698).NotStarted;
        this.hasInputError = false;
        this._currentInput = "";
        this._errorPositions = [];
        this._startTime = null;
        this._endTime = null;
        this._characterCount = 0;
        this._totalCharacterCount = 0;
        this._wpm = 0;
        this._accuracy = 0;
        this.wordProvider = wordProvider;
        this.testSize = numberOfWords;
        this.reset();
    }
    get errorPositions() {
        return this._errorPositions;
    }
    get currentInput() {
        return this._currentInput;
    }
    get state() {
        return this._state;
    }
    getWords() {
        return this.words;
    }
    getCurrentWordIndex() {
        return this.currentWordIndex;
    }
    consumeWord() {
        if (this.words[this.currentWordIndex] !== this._currentInput) this._errorPositions.push(this.currentWordIndex);
        else this._characterCount += this._currentInput.length + 1; // input + space
        this._totalCharacterCount += this.words[this.currentWordIndex].length + 1; // word + space
        this.currentWordIndex++;
        if (this.currentWordIndex === this.words.length) {
            this._endTime = Date.now();
            this._state = (0, $ee002d249712e741$export$77ae2534b1d2e698).Completed;
            this.calculateWPM();
        }
        this._currentInput = "";
        this.hasInputError = false;
    }
    checkWord(matchString) {
        this._currentInput = matchString;
        this.hasInputError = false;
        if (this._state === (0, $ee002d249712e741$export$77ae2534b1d2e698).NotStarted) {
            this._startTime = Date.now();
            this._state = (0, $ee002d249712e741$export$77ae2534b1d2e698).InProgress;
        }
        const currentWord = this.words[this.currentWordIndex];
        if (matchString === "") {
            this.hasInputError = false;
            return;
        }
        if (matchString.length > currentWord.length) {
            this.hasInputError = true;
            return;
        }
        if (!currentWord.startsWith(matchString)) {
            this.hasInputError = true;
            return;
        }
        if (this.currentWordIndex === this.words.length - 1) {
            if (currentWord === matchString) {
                this.hasInputError = false;
                this.consumeWord();
            }
        }
        this.hasInputError = false;
    }
    calculateWPM() {
        if (this.state == (0, $ee002d249712e741$export$77ae2534b1d2e698).Completed) {
            const end = this._endTime || 0;
            const start = this._startTime || 0;
            const durationMillis = end - start;
            const wordCount = this._characterCount / 5;
            const durationMinutes = durationMillis / 66000;
            this._wpm = wordCount / durationMinutes;
            this._accuracy = this._characterCount / this._totalCharacterCount * 100;
        }
    }
    inputError() {
        return this.hasInputError;
    }
    reset() {
        this.currentWordIndex = 0;
        this._state = (0, $ee002d249712e741$export$77ae2534b1d2e698).NotStarted;
        this.hasInputError = false;
        this.words = this.wordProvider.getWords(this.testSize);
        this._currentInput = "";
        this._errorPositions = [];
        this._startTime = null;
        this._endTime = null;
        this._characterCount = 0;
        this._totalCharacterCount = 0;
    // this._accuracy = 0;
    }
    get wpm() {
        return this._wpm;
    }
    get accuracy() {
        return this._accuracy;
    }
    getDebugInfo() {
        return `
            Current Word Index: ${this.getCurrentWordIndex()}
            Test State: ${this.state}
            Input Error: ${this.inputError()}
            Current Word: ${this.getWords()[this.getCurrentWordIndex()]}
            Current Input: ${this.currentInput}
            Error Positions: ${this.errorPositions}
        stats:
            Start Time: ${this._startTime}
            End Time: ${this._endTime}
            Duration: ${(this._startTime || 0) - (this._endTime || 0)}
            Character count: ${this._characterCount}
            Total Character Count: ${this._totalCharacterCount}
            WPM: ${this._wpm}
            Accuracy: ${this._accuracy}%

            `;
    }
    get completed() {
        return this.state === (0, $ee002d249712e741$export$77ae2534b1d2e698).Completed;
    }
    get inProgress() {
        return this.state === (0, $ee002d249712e741$export$77ae2534b1d2e698).InProgress;
    }
    get notStarted() {
        return this.state === (0, $ee002d249712e741$export$77ae2534b1d2e698).NotStarted;
    }
}


const $4f695cdd1191b1da$export$cd80a8f028a50810 = `be
and
of
a
in
to
have
too
it
I
that
for
you
he
with
on
do
say
this
they
at
but
we
his
from
that
not
can
won
by
she
or
as
what
go
their
can
who
get
if
would
her
all
my
make
about
know
will
as
up
one
time
there
year
so
think
when
which
them
some
me
people
take
out
into
just
see
him
your
come
could
now
than
like
other
how
then
its
our
two
more
these
want
way
look
first
also
new
because
day
more
use
no
man
find
here
thing
give
many
well
only
those
tell
one
very
her
even
back
any
good
woman
through
us
life
child
there
work
down
may
after
should
call
world
over
school
still
try
in
as
last
ask
need
too
feel
three
when
state
never
become
between
high
really
something
most
another
much
family
own
out
leave
put
old
while
mean
on
keep
student
why
let
great
same
big
group
begin
seem
country
help
talk
where
turn
problem
every
start
hand
might
American
show
part
about
against
place
over
such
again
few
case
most
week
company
where
system
each
right
program
hear
so
question
during
work
play
government
run
small
number
off
always
move
like
night
live
Mr
point
believe
hold
today
bring
happen
next
without
before
large
all
million
must
home
under
water
room
write
mother
area
national
money
story
young
fact
month
different
lot
right
study
book
eye
job
word
though
business
issue
side
kind
four
head
far
black
long
both
little
house
yes
after
since
long
provide
service
around
friend
important
father
sit
away
until
power
hour
game
often
yet
line
political
end
among
ever
stand
bad
lose
however
member
pay
law
meet
car
city
almost
include
continue
set
later
community
much
name
five
once
white
least
president
learn
real
change
team
minute
best
several
idea
kid
body
information
nothing
ago
right
lead
social
understand
whether
back
watch
together
follow
around
parent
only
stop
face
anything
create
public
already
speak
others
read
level
allow
add
office
spend
door
health
person
art
sure
such
war
history
party
within
grow
result
open
change
morning
walk
reason
low
win
research
girl
guy
early
food
before
moment
himself
air
teacher
force
offer
enough
both
education
across
although
remember
foot
second
boy
maybe
toward
able
age
off
policy
everything
love
process
music
including
consider
appear
actually
buy
probably
human
wait
serve
market
die
send
expect
home
sense
build
stay
fall
oh
nation
plan
cut
college
interest
death
course
someone
experience
behind
reach
local
kill
six
remain
effect
use
yeah
suggest
class
control
raise
care
perhaps
little
late
hard
field
else
pass
former
sell
major
sometimes
require
along
development
themselves
report
role
better
economic
effort
up
decide
rate
strong
possible
heart
drug
show
leader
light
voice
wife
whole
police
mind
finally
pull
return
free
military
price
report
less
according
decision
explain
son
hope
even
develop
view
relationship
carry
town
road
drive
arm
true
federal
break
better
difference
thank
receive
value
international
building
action
full
model
join
season
society
because
tax
director
early
position
player
agree
especially
record
pick
wear
paper
special
space
ground
form
support
event
official
whose
matter
everyone
center
couple
site
end
project
hit
base
activity
star
table
need
court
produce
eat
American
teach
oil
half
situation
easy
cost
industry
figure
face
street
image
itself
phone
either
data
cover
quite
picture
clear
practice
piece
land
recent
describe
product
doctor
wall
patient
worker
news
test
movie
certain
north
love
personal
open
support
simply
third
technology
catch
step
baby
computer
type
attention
draw
film
Republican
tree
source
red
nearly
organization
choose
cause
hair
look
point
century
evidence
window
difficult
listen
soon
culture
billion
chance
brother
energy
period
course
summer
less
realize
hundred
available
plant
likely
opportunity
term
short
letter
condition
choice
place
single
rule
daughter
administration
south
husband
Congress
floor
campaign
material
population
well
call
economy
medical
hospital
church
close
thousand
risk
current
fire
future
wrong
involve
defense
anyone
increase
security
bank
myself
certainly
west
sport
board
seek
per
subject
officer
private
rest
behavior
deal
performance
fight
throw
top
quickly
past
goal
second
bed
order
author
fill
represent
focus
foreign
drop
plan
blood
upon
agency
push
nature
color
no
recently
store
reduce
sound
note
fine
before
near
movement
page
enter
share
than
common
poor
other
natural
race
concern
series
significant
similar
hot
language
each
usually
response
dead
rise
animal
factor
decade
article
shoot
east
save
seven
artist
away
scene
stock
career
despite
central
eight
thus
treatment
beyond
happy
exactly
protect
approach
lie
size
dog
fund
serious
occur
media
ready
sign
thought
list
individual
simple
quality
pressure
accept
answer
hard
resource
identify
left
meeting
determine
prepare
disease
whatever
success
argue
cup
particularly
amount
ability
staff
recognize
indicate
character
growth
loss
degree
wonder
attack
herself
region
television
box
TV
training
pretty
trade
deal
election
everybody
physical
lay
general
feeling
standard
bill
message
fail
outside
arrive
analysis
benefit
name
sex
forward
lawyer
present
section
environmental
glass
answer
skill
sister
PM
professor
operation
financial
crime
stage
ok
compare
authority
miss
design
sort
one
act
ten
knowledge
gun
station
blue
state
strategy
little
clearly
discuss
indeed
force
truth
song
example
democratic
check
environment
leg
dark
public
various
rather
laugh
guess
executive
set
study
prove
hang
entire
rock
design
enough
forget
since
claim
note
remove
manager
help
close
sound
enjoy
network
legal
religious
cold
form
final
main
science
green
memory
card
above
seat
cell
establish
nice
trial
expert
that
spring
firm
Democrat
radio
visit
management
care
avoid
imagine
tonight
huge
ball
no
close
finish
yourself
talk
theory
impact
respond
statement
maintain
charge
popular
traditional
onto
reveal
direction
weapon
employee
cultural
contain
peace
head
control
base
pain
apply
play
measure
wide
shake
fly
interview
manage
chair
fish
particular
camera
structure
politics
perform
bit
weight
suddenly
discover
candidate
top
production
treat
trip
evening
affect
inside
conference
unit
best
style
adult
worry
range
mention
rather
far
deep
front
edge
individual
specific
writer
trouble
necessary
throughout
challenge
fear
shoulder
institution
middle
sea
dream
bar
beautiful
property
instead
improve
stuff
claim`.split('\n');


class $a6ae8c2c5ba1e5e4$export$870e9e46069e1c48 {
    constructor(poolSize = 1000){
        this.poolSize = 1000;
        this.pool = (0, $4f695cdd1191b1da$export$cd80a8f028a50810);
        this.poolSize = poolSize;
    }
    getWords(count) {
        const selectedWords = [];
        for(let i = 0; i < count; i++){
            const index = Math.floor(Math.random() * this.poolSize);
            selectedWords.push(this.pool[index]);
        }
        return selectedWords;
    }
}


class $d9d43a569626a590$export$41c09b06237d17f2 {
    constructor(typingTest, scroller){
        this.input = this.$('#input');
        this.wordWrapper = this.$('#word-wrapper');
        this.newButton = this.$('#new_test');
        this.debug = this.$('#debug');
        this.wpm = this.$('#wpm');
        this.accuracy = this.$('#accuracy');
        this.test = typingTest;
        this._scroller = scroller;
        this.init();
    }
    $(selector) {
        return document.querySelector(selector);
    }
    init() {
        this.input.focus();
        this.addEventListeners();
        this.render();
    }
    renderDebug() {
        this.debug.innerHTML = `
        Test Debug:
            ${this.test.getDebugInfo()}
        Scroll Debug:
            Scroll: ${this._scroller.getDebugInfo()}
        `;
    }
    render() {
        const hasInputError = this.test.inputError();
        this.wordWrapper.innerHTML = this.test.getWords().map((word, index)=>{
            const hasError = this.test.errorPositions.includes(index);
            if (hasInputError && index === this.test.getCurrentWordIndex()) return `<span class="word word__incorrect word__current">${word}</span>`;
            if (index === this.test.getCurrentWordIndex()) return `<span class="word word__current">${word}</span>`;
            if (hasError) return `<span class="word word__incorrect">${word}</span>`;
            if (index < this.test.getCurrentWordIndex()) return `<span class="word word__correct">${word}</span>`;
            return `<span class="word__pending">${word}</span>`;
        }).join(' ');
        this._scroller.scrollToCurrentWord(this.test.getCurrentWordIndex());
        this.wpm.innerHTML = Math.round(this.test.wpm).toString();
        this.accuracy.innerHTML = `${Math.round(this.test.accuracy)}%`;
    }
    handleInput() {
        const value = this.input.value;
        const length = value.length;
        if (value[length - 1] === ' ') {
            this.test.consumeWord();
            this.input.value = '';
            this.render();
            return;
        }
        this.test.checkWord(value);
        if (this.test.completed) this.input.value = '';
        this.render();
    }
    addEventListeners() {
        this.newButton.addEventListener('click', ()=>{
            this.test.reset();
            this.render();
            this.input.value = "";
            this.input.focus();
            this._scroller.reset();
        });
        this.input.addEventListener('input', ()=>this.handleInput());
    }
}


class $79461088065904e2$export$8510c5cea0d6e753 {
    constructor(wordWrapperId){
        this._containerTop = 0;
        this.container = document.getElementById(wordWrapperId);
    }
    reset() {
        this._containerTop = 0;
        this._initialOffset = 0;
        this._currentOffset = 0;
        this.applyScroll();
    }
    scrollToCurrentWord(currentWordIndex) {
        const currentWord = this.container.children[currentWordIndex];
        const currentWordTop = currentWord?.getBoundingClientRect().top;
        if (currentWordIndex === 0) this._initialOffset = currentWordTop;
        this._currentOffset = currentWordTop;
        if (this._initialOffset !== this._currentOffset && currentWordTop !== this._initialOffset) this._containerTop += this._initialOffset - this._currentOffset;
        this.applyScroll();
    }
    applyScroll() {
        this.container.style.top = `${this._containerTop}px`;
    }
    getDebugInfo() {
        return `
            Initial Offset: ${this._initialOffset}
            Current Offset: ${this._currentOffset}
            Container Top: ${this._containerTop}
            
            `;
    }
}


const $29fa71945607a2e5$var$wordProvider = new (0, $a6ae8c2c5ba1e5e4$export$870e9e46069e1c48)(225);
const $29fa71945607a2e5$var$test = new (0, $c5cbdfd32a1fc02c$export$c87cf3bdf124c216)($29fa71945607a2e5$var$wordProvider, 20);
const $29fa71945607a2e5$var$app = new (0, $d9d43a569626a590$export$41c09b06237d17f2)($29fa71945607a2e5$var$test, new (0, $79461088065904e2$export$8510c5cea0d6e753)('word-wrapper'));


//# sourceMappingURL=index.1701ae44.js.map
